<template>
    <div id="optimization">
        <div class="title">品控优化建议</div>
        <div class="main mr40">
            <div class="content-good">
                <div class="left-content">
                    <p class="good-title"> {{ title }} </p>
                    <p class="good-size">
                        {{ skuName }}
                        <!-- <span>单价：2678 元</span>
                        <span>运行内存：8GB</span>
                        <span>机身内存：256GB</span>   -->
                    </p>
                </div>
                <div class="right-image">
                    <img :src="imgUrl" alt="">
                </div>
            </div>
            <el-table :data="data" border style="width: 100%" v-loading="loading">
                <el-table-column prop="propertyName" label="品控要数"> </el-table-column>
                <el-table-column prop="warnningReason" label="填写状况"> </el-table-column>
                <el-table-column prop="importantLevel" label="影响程度"> </el-table-column>
                <el-table-column prop="proveAdvice" label="修改建议"> </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="handleSizeChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
            <div class="back-on-page">
                <el-button style="padding: 12px 24px" @click="backonPage">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { timeUtils } from '@/utils/time.js'
import { getSessionStorage } from '@/utils/auth.js'
import { getGoodsAdvicePropertyList } from '@/api/qualityControl'
export default {
    name: 'optimization',
    data () {
        return {
            imgUrl: '',
            tableData: [],
            page: 1,
            size: 10,
            total: 0,
            loading: true,
            title: '',
            skuName: '',
        }
    },
    computed: {
        data () {
            return this.tableData.map(item => {
                let importantLevel = item.importantLevel, status = '轻微';
                if (importantLevel == 2) {
                    status = '中等';
                } else if (importantLevel == 3) {
                    status = '严重';
                }
                return {...item,importantLevel: status }
            })
        }
    },
    methods: {
        sizeChange (size) {
            this.size = size;
            this.initTable();
        },
        handleSizeChange (page) {
            this.page = page;
            this.initTable();
        },
        backonPage () {
            let page = this.$route.query.page;
            let size = this.$route.query.size;
            this.$router.push({ path: '/home/qualityControl', query: { page, size } });
        },
        initTable () {
            this.loading = true;
            let data = {
                goodsids: this.$route.query.goodsids,
                page: this.page,
                size: this.size
            }
            getGoodsAdvicePropertyList(data)
                .then(res => {
                    if (res.status == 200) {
                        this.tableData = res.data.data;
                        this.total = res.data.total;
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch(err => {
                    this.$message.error(err.message);
                })
                .finally(_ => {
                    this.loading = false;
                })
        }
    },
    mounted () {},
    created () {
        this.title = this.$route.query.title; 
        this.skuName = this.$route.query.skuName;
        this.imgUrl = this.$route.query.imgUrl;
        this.initTable();
    }
}
</script>

<style lang='scss' scoped>
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        font-size: 18px;
        color: #333;
        width: 100%;
        padding: 15px 32px;
    }

    .main {
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 30px;
        padding-bottom: 70px;
        min-width: 1200px;
    }

    .table {
        position: relative;
        .el-button {
            position: absolute;
            left: 300px;
            top: 0px;
            z-index: 1;
        }
    }

    .main {
        .content-good {
            display: flex;
            margin-bottom: 24px;
            .left-content {
                padding: 12px 24px 12px 24px;
                width: 54%;
                margin-right: 2%;
                text-align: center;
                .good-title {
                    line-height: 30px;
                    font-size: 18px;
                    font-weight: 600;
                }
                .good-size {
                    line-height: 30px;
                    text-indent: 12px;
                    margin-top: 12px;
                    span:not(:first-child) {
                        margin-left: 24px;
                    }
                }
            }
            .right-image {
                width: 42%;
                max-height: 220px;
                padding: 12px;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    // width: 300px;
                    max-height: 250px;
                }
            }
        }
        .back-on-page {
            display: flex;
            width: 100%;
            justify-content: center;
        }
        .el-form {
            display: flex;
            flex-wrap: wrap;
        }
    }
    .mr40 {
        .el-form-item {
            margin-right: 40px;
        }
        .mr20 {
            margin-right: 10px;
        }
    }

    ::v-deep .el-range-separator {
        padding: 0px;
    }

    .page {
        margin-top: 12px;
        float: right;
    }
</style>